import { Pipe, PipeTransform } from '@angular/core';
import { Project } from '../../state/project.model';

@Pipe({
  name: 'projectFilter'
})
export class ProjectFilterPipe implements PipeTransform {

  transform(items: Project[], term: string): unknown {
    if (!items) {
      return [];
    }
    if (!term) {
      return items;
    }

    term = term.toLowerCase();
    return items.filter(it => {
      return it.name.toLowerCase().includes(term);
    });
  }

}
